import React, { useState, useEffect } from "react";
import styles from "./ScoreBoard.module.css";
import supabase from "../../utils/supabase";

const ScoreBoard = ({ isExpanded, toggleExpanded }) => {
  const [scores, setScores] = useState([]);

  useEffect(() => {
    async function fetchScores() {
      const { data, error } = await supabase
        .from("Scores")
        .select("Score, Name")
        .not("Score", "is", null)
        .order("Score", { ascending: false })
        .limit(15);

      if (error) {
        console.error("Error fetching scores:", error.message);
      } else {
        setScores(data);
      }
    }

    if (isExpanded) fetchScores();
  }, [isExpanded]);

  return (
    <>
      {isExpanded ? <div className={styles.backdrop}></div> : ""}
      <div
        className={isExpanded ? styles.scoreBoardExpanded : styles.scoreBoard}
      >
        <button
          className={
            isExpanded ? styles.toggleButtonExpanded : styles.toggleButton
          }
          onClick={toggleExpanded}
        >
          {isExpanded ? "Close" : "Scoreboard"}
        </button>
        {isExpanded && (
          <div className={styles.scoreList}>
            <p>Top 15 Players</p>
            <ol>
              {scores.map((score, index) => (
                <li
                  key={index + 1}
                  className={
                    index === 0
                      ? styles.top1
                      : index === 1
                      ? styles.top2
                      : index === 2
                      ? styles.top3
                      : null
                  }
                >
                  {index + 1}. {score.Name} - {score.Score} pt
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </>
  );
};

export default ScoreBoard;
